
import { Button, Form, Input, Modal, Switch, Tabs, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import highlightBoxService from '../../services/highlight-box-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import UploadImage from '../../components/upload/image';
import EditableTagGroup from '../../components/input/editable-tag-group';
import { fileTYPE_IMG, groupType, VISIBILITY_DEFAULT } from '../../constants/app-constants';
import fileUtils from '../../utils/file-utils';
import VisibilityFormItem from '../../components/input/visibility-form-item';
import { FORM_LANG, formText, imageSizeHint, langOfTab } from '../../constants/form-i18n';

const { TabPane } = Tabs;

const defaultValue = {
    highlightBoxImage: null,
    isOpenNewTab: false,
    keywordList: [],
};

const AddEditHighlightBoxDialog = ({ isShow, onCancel, onSaveComplete, editData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [highlightBoxImage, setHighlightBoxImage] = useState(defaultValue.highlightBoxImage);
    const [keywordList, setKeywordList] = useState(defaultValue.keywordList);
    // NMU-444: the active tab drives the language of the whole dialog.
    const [lang, setLang] = useState(FORM_LANG.TH);
    const t = formText(lang);

    useEffect(() => {
        if (!isShow) {
            setHighlightBoxImage(defaultValue.highlightBoxImage);
            setKeywordList(defaultValue.keywordList);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                titleTH: editData.title.titleTH,
                titleEN: editData.title.titleEN,
                url: editData.url,
                status: editData.status,
                totalView: editData.totalView,
                enableNewTab: editData.enableNewTab,
                visibility: editData.visibility ? editData.visibility : VISIBILITY_DEFAULT
            });
            setHighlightBoxImage(editData.attachImage);
            setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            const values = await form.validateFields();
            try {

                dispatch(appLoaderAction.enable());

                if (!editData) {
                    let bean = {
                        title: {
                            titleTH: values.titleTH,
                            titleEN: values.titleEN,
                        },
                        keywordList: keywordList,
                        url: values.url,
                        attachImage: highlightBoxImage,
                        enableNewTab: values.enableNewTab,
                        status: values.status,
                        /*
                          NMU-530: no userGroup at all.

                          NMU-432 took the choice out of this form, and this line
                          kept stamping every new highlight 'prospective' so the
                          site's old grouping had something to bucket on. NMU-436
                          made the "การแสดงผลไฮไลท์" tabs the source of truth, so
                          the stamp only made the site show a group the admin had
                          never arranged — which is the defect this ticket
                          reports. A highlight belongs to a tab because an editor
                          put it there, not because it was born.
                        */
                        visibility: values.visibility,
                        totalView: 0
                    };

                    await highlightBoxService.add({ bean: bean });
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    bean.title.titleTH = values.titleTH;
                    bean.title.titleEN = values.titleEN;
                    bean.keywordList = keywordList;
                    bean.url = values.url;
                    bean.attachImage = highlightBoxImage;
                    bean.enableNewTab = values.enableNewTab;
                    bean.status = values.status;
                    // NMU-432: field removed from the form — keep whatever the record
                    // already has instead of clearing it on every save.
                    bean.visibility = values.visibility;
                    bean.totalView = editData.totalView;
                    await highlightBoxService.edit({ bean: bean });
                }

                dispatch(appLoaderAction.disale());
                notifyUtitls.success(t('successTitle'), t('saveSuccess'));
                onSaveComplete();
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning(t('warningTitle'), t('incompleteForm'));
        }
    };

    const onUploadTemp = ({ file }) => {
        if (file.status === 'done') {
            const { bean } = file.response;
            setHighlightBoxImage(bean);
        }
    };

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        t(editData ? 'editHighlightBox' : 'addHighlightBox')
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />{t('save')}
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            {t('cancel')}
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_hightlight_box"
                        preserve={false}
                        form={form}
                        initialValues={{ status: true, enableNewTab: true, visibility: VISIBILITY_DEFAULT }}
                        validateMessages={{
                            required: t('required'),
                        }}>
                        <Tabs defaultActiveKey="1" onChange={(key) => setLang(langOfTab(key))}>
                            <TabPane tab={t('tabThai')} key="1" forceRender>
                                <Form.Item
                                    label={t('highlightName')}
                                    name="titleTH"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    <Input />
                                </Form.Item>
                            </TabPane>
                            <TabPane tab={t('tabEnglish')} key="2" forceRender>
                                <Form.Item
                                    label="Title"
                                    name="titleEN"
                                    className="mb-4"
                                >
                                    <Input />
                                </Form.Item>
                            </TabPane>
                        </Tabs>


                        <Form.Item
                            label={t('image')}
                            valuePropName="fileList"
                            name="imageHeader"
                            rules={[
                                {
                                    required: highlightBoxImage ? false : true,
                                    // NMU-532: a picture is uploaded, not typed.
                                    message: 'กรุณาอัปโหลดรูปภาพ',
                                },
                            ]}>
                            <UploadImage
                                listType="picture-card"
                                accept={fileTYPE_IMG}
                                showUploadList={false}
                                onChange={onUploadTemp}
                                className={highlightBoxImage ? 'view-upload' : null}>
                                {highlightBoxImage ? (
                                    <img
                                        src={
                                            highlightBoxImage.tempFilename
                                                ? fileUtils.getTempFileRenderUrl(
                                                    highlightBoxImage.tempFilename,
                                                    highlightBoxImage.type
                                                )
                                                : fileUtils.getFileRenderUrl(
                                                    groupType.HIGHLIGHT_BOX,
                                                    editData ? editData.highlightBoxId : null,
                                                    highlightBoxImage.originalFilename
                                                )
                                        }
                                        alt="avatar"
                                        // style={{ width: '100%' }}
                                    />
                                ) : t('uploadFile')}
                            </UploadImage>
                            <label className="text-danger">{imageSizeHint(lang, '48x48 pixels')}</label>
                        </Form.Item>

                        <Form.Item label={t('link')} name="url"
                          rules={[
                              {
                                  required: true,
                              },
                          ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item label={t('keywords')} >
                            <EditableTagGroup onChange={setKeywordList} tags={keywordList} lang={lang} />
                        </Form.Item>

                        <Form.Item label={t('openInNewTab')} name="enableNewTab" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                        <Form.Item label={t('status')} name="status" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                        <VisibilityFormItem lang={lang} />

                    </Form>
                </Modal>
            </div>
        </div>
    )
}

export default AddEditHighlightBoxDialog;
